import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filter",
  standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(countries: any, SearchText: string): any {
    if (!SearchText) {
      return countries;
    }
    return countries.filter((country: any) => {
      const nameMatches = country.name.toLowerCase().includes(SearchText.toLowerCase());
      const phoneCodeMatches = country.phoneCodes.some((code: string) => code.toLowerCase().includes(SearchText));
      return nameMatches || phoneCodeMatches;
    });
  }
}
